function redirectToLogin(returnTo?: string) : string{
    if (returnTo) {
        return `/login?returnTo=${encodeURIComponent(returnTo)}`;
    }
    return "/login";
}

function redirectToHome() : string{
    return "/dashboard";
}

function redirectToProfile() : string{
    return "/profile";
}

function redirectToHistory() : string{
    return "/history";
}


const RedirectionService = {
    redirectToLogin,
    redirectToHome,
    redirectToProfile,
    redirectToHistory,
}

export default RedirectionService;